import axios from 'axios'
import CONFIG from './Config.js'

const BASEURL = (CONFIG.PRODUCTION === true) ? "https://ecfc.afework.io" : "http://localhost:5000"

export default {
  login: async function(username, password){
    const params = {
        username: username,
        password: password
    }

    const payload = {   
        //headers: PodcastHeaders,
        params: params,
        origin: BASEURL
    }

    axios.defaults.withCredentials = true
    let response = await axios.post(`${BASEURL}/api/login`, payload)
    let result = response.data
    return result 
  },
  session: async function(){
    
    const payload = {   
        //headers: PodcastHeaders,
        origin: BASEURL
    }

    axios.defaults.withCredentials = true
    let response = await axios.get(`${BASEURL}/api/session`, payload)
    let result = response.data
    return result 
  },
  logout: async function(username, password){
    const payload = {   
        origin: BASEURL
    }

    axios.defaults.withCredentials = true
    let response = await axios.get(`${BASEURL}/api/logout`, payload)
    let result = response.data
    return result 
  },
  messages: async function(){
    // TODO handle pagination
    const payload = {   
        origin: BASEURL
    }

    axios.defaults.withCredentials = true
    let response = await axios.get(`${BASEURL}/api/messages`, payload)
    let result = response.data.messages
    return result 
  },
  uploadContacts: async function(contacts, groups){

      var params = {
        contacts:contacts
      }

      if(groups.length === 1){
        const group = groups[0]
        params.groupId = group.groupId
      }

      const payload = {   
        origin: BASEURL,
        params: params
    }

    axios.defaults.withCredentials = true
    let response = await axios.post(`${BASEURL}/api/contacts`, payload)
    let result = response.data
    return result 
  },
  deleteContact: async function(memberId){
    const params = {
      memberId:memberId
    }

    const payload = {   
      origin: BASEURL,
      params: params
    }

    axios.defaults.withCredentials = true
    let response = await axios.post(`${BASEURL}/api/contacts/remove`, payload)
    let result = response.data
    return result 
  },
  searchContact: async function(groupId,searchText){
    const params = {
      searchText:searchText,
      groupId: groupId
    }

    const payload = {   
        origin: BASEURL,
        params: params
    }

    axios.defaults.withCredentials = true
    let response = await axios.post(`${BASEURL}/api/contacts/search`, payload)
    let result = response.data.results
    return result 
  },
  addGroupMember: async function(groupId,memberId){
    const params = {
      memberId:memberId,
      groupId: groupId
    }

    const payload = {   
        origin: BASEURL,
        params: params
    }

    axios.defaults.withCredentials = true
    let response = await axios.post(`${BASEURL}/api/groups/members/add`, payload)
    let result = response.data
    return result 
  },
  removeGroupMember: async function(groupId,memberId){
    const params = {
      memberId:memberId,
      groupId: groupId
    }

    const payload = {   
        origin: BASEURL,
        params: params
    }

    axios.defaults.withCredentials = true
    let response = await axios.post(`${BASEURL}/api/groups/members/remove`, payload)
    let result = response.data
    return result 
  },
  groups: async function(){
    const payload = {   
        origin: BASEURL
    }

    axios.defaults.withCredentials = true
    let response = await axios.get(`${BASEURL}/api/groups`, payload)
    let result = response.data.groups
    return result 
  },
  groupMembers: async function(groupIds){

    const params = {
      groupIds:groupIds
    }

    const payload = {   
        origin: BASEURL,
        params: params
    }

    axios.defaults.withCredentials = true
    let response = await axios.post(`${BASEURL}/api/groups/members`, payload)
    let result = response.data.groups
    return result 
  },
  createGroup: async function(name){
    const params = {
      name:name
    }

    const payload = {   
        origin: BASEURL,
        params: params
    }

    axios.defaults.withCredentials = true
    let response = await axios.post(`${BASEURL}/api/groups`, payload)
    let result = response.data.group
    return result 
  },
  renameGroup: async function(groupId,name){
    const params = {
      name:name,
      groupId:groupId
    }

    const payload = {   
        origin: BASEURL,
        params: params
    }

    axios.defaults.withCredentials = true
    let response = await axios.post(`${BASEURL}/api/groups`, payload)
    let result = response.data.group
    return result 
  },
  deleteGroup: async function(groupId){
    const params = {
      groupId:groupId
    }

    const payload = {   
        origin: BASEURL,
        params: params
    }

    axios.defaults.withCredentials = true
    let response = await axios.delete(`${BASEURL}/api/groups`, payload)
    let result = response.data
    return result 
  },
  contacts: async function(){
    // TODO handle pagination
    const payload = {   
        origin: BASEURL
    }

    axios.defaults.withCredentials = true
    let response = await axios.get(`${BASEURL}/api/contacts`, payload)
    let result = response.data.contacts
    return result 
  },
  deleteContacts: async function(){
    // TODO handle pagination
    const payload = {   
        origin: BASEURL
    }

    axios.defaults.withCredentials = true
    let response = await axios.delete(`${BASEURL}/api/contacts`, payload)
    let result = response.data.contacts
    return result 
  },
  sendMessage: async function(groupIds,message){
    const params = {
      message: message,
      groupIds:groupIds
    }

    const payload = {   
        params: params,
        origin: BASEURL,
        withCredentials:true
    }

    axios.defaults.withCredentials = true
    let response = await axios.post(`${BASEURL}/api/message/send`, payload)
    let result = response.data
    return result 
  }
}